import produce from 'immer';
import { Reducer } from 'redux';

import { AdditionalStagesState, AdditionalStagesTypes } from '../types';

const initialState: AdditionalStagesState = {
    isLoading: false,
    additionalStages: [],
};

const additionalStagesReducer: Reducer<AdditionalStagesState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case AdditionalStagesTypes.GET_LIST: {
                draft.isLoading = false;
                draft.additionalStages = action.payload.additionalStages;
                break;
            }
            case AdditionalStagesTypes.REQUEST_GET_LIST: {
                draft.isLoading = true;
                break;
            }
            case AdditionalStagesTypes.SAVE_ADDITIONAL_STAGE: {
                draft.isLoading = false;

                draft.additionalStages = action.payload.additionalStage
                    ? draft.additionalStages.find((item) => item.id === action.payload.additionalStage.id)
                        ? draft.additionalStages.map((item) => {
                              return item.id === action.payload.additionalStage.id
                                  ? action.payload.additionalStage
                                  : item;
                          })
                        : [...draft.additionalStages, action.payload.additionalStage]
                    : [...draft.additionalStages];
                break;
            }
            case AdditionalStagesTypes.REQUEST_SAVE_ADDITIONAL_STAGE: {
                draft.isLoading = true;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

export { additionalStagesReducer };
